/**
 * A day's letter is its place in the week (`D215`) — the app's copy of
 * `@repo/training`'s `dayLetters`, for the outbox's optimistic drawing: a day
 * added, removed or moved offline is drawn with the letters the server will
 * store, so the tab does not show one letter and the refetch another.
 *
 * A LETTERED label is a single capital letter, or a word and a capital letter
 * ("Upper A"); within each word's group the labels take A, B, C… in day
 * order. Anything else is left alone and uses no letter. Pure and idempotent
 * (`T-221`). `__tests__/day-letters.test.ts` runs the domain test's table.
 */
const LETTERED = /^(?:(.+) )?([A-Z])$/;
const FIRST = "A".charCodeAt(0);
/** The labels of a week in day order, re-lettered — same length, same order. */
export function dayLetters(labels) {
    const used = new Map();
    return labels.map((label) => {
        const match = LETTERED.exec(label);
        if (match === null) {
            return label;
        }
        const group = match[1] ?? "";
        const index = used.get(group) ?? 0;
        used.set(group, index + 1);
        if (index >= 26) {
            return label;
        }
        const letter = String.fromCharCode(FIRST + index);
        return group === "" ? letter : `${group} ${letter}`;
    });
}
/**
 * `sessions` (in day order) with each lettered label re-lettered — the SAME
 * array when nothing changed, so a re-applied patch costs no re-render.
 */
export function reletterSessions(sessions) {
    const letters = dayLetters(sessions.map((session) => session.label));
    let changed = false;
    const next = sessions.map((session, index) => {
        const label = letters[index] ?? session.label;
        if (label === session.label) {
            return session;
        }
        changed = true;
        return { ...session, label };
    });
    return changed ? next : sessions;
}
//# sourceMappingURL=day-letters.js.map